const MedicalAdvice = [
  " Nuts may help you lose weight and reduce the risk of developing type 2 diabetes and heart disease",
  " Studies show that people who eat fish regularly have a lower risk for several conditions, including heart disease, dementia, and inflammatory bowel disease",
  " Poor sleep can drive insulin resistance, can disrupt your appetite hormones, and reduce your physical and mental performance",
  "Drinking water is the best way to stay hydrated, as it's free of calories, sugar, and additives.",
  "Doing aerobic exercise, or cardio, is one of the best things you can do for your mental and physical health.",
  "Smoking, harmful use of drugs, and alcohol abuse can all seriously negatively affect your health. ",
  "Added sugar is extremely prevalent in modern food and drinks. A high intake is linked to obesity, type 2 diabetes, and heart disease ",
];

export default MedicalAdvice;
